import React from 'react';
import { ListBase, useRecordContext, TextField, useStore, useListContext, 
  TextInput, SelectInput, RadioButtonGroupInput, ExportButton, Filter,
  Pagination } from 'react-admin';
import DatagridConfigurable from '../../lib/DatagridConfigurable.tsx';
import { SelectColumnsButton } from '../../lib/SelectColumnsButton.tsx';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';


const ListToolbar = () => {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={{xs: 1, sm: 2, md: 4}}>
        <ListFilter />
        <ExportButton />
        <Stack alignItems="flex-start">
          <SelectColumnsButton />
        </Stack>
      </Stack>
    </>
  )
}

const viewChoices = [
  {id: 'act',  name: 'Aktive'},
  {id: 'min',     name: 'Minimized'},
  {id: 'os',      name: 'OS Version'},
]

const timeChoices = [
  {id: 'day',     name: '1 Day'},
  {id: 'week',    name: '1 Week'},
  {id: 'month',   name: '1 Month'},
  {id: '99d',     name: '99 Days'},
  {id: 'year',    name: '1 Year'},
  {id: 'all',     name: 'All'},
]

const osChoices = [
  {id: 'all',     name: 'Alle'},
  {id: 'W',       name: 'Windows'},
  {id: 'M',       name: 'Mac'},
  {id: 'L',       name: 'Linux'},
]

const MyPagination = props => <Pagination rowsPerPageOptions={[50,100,500,1000]} {...props} />

const bgColors = ['#A0FFA0', '#FFFF80', '#D0D070', '#CCCCCC', '#999999', '#777777', '#FFFFFF']

const ListFilter = ({ ...props }) => {
  const [columns, setColumns] = useStore(`preferences.globApp.datagrid.columns`, []);
  const [availableColumns] = useStore(`preferences.globApp.datagrid.availableColumns`, []);
  const { setSort } = useListContext()

  const handleColumns = (sources=[]) => {
    const indexes = sources
      .map(source =>
          availableColumns.find(c => c.source === source)
      )
      .filter(Boolean)
      .map(c => String(c.index));

    if (!indexes.length) {
        return;
    }
    setColumns(indexes);
  };

  if(columns?.length === 0){
    handleColumns(['version', 'rev', 'platform', 'versionstring', 'api', 'link', 'first_seen', 'update_cnt', 'last_hostel', 'last_seen', 'db_version_id'], true)
  }

  const handleViewChange = (ev) => {
    if(ev?.target?.value==='min'){
      handleColumns(['version', 'rev', 'platform', 'versionstring', 'api', 'link', 'first_seen', 'update_cnt', 'last_hostel', 'last_seen'], true)
      setSort({field: 'version', order: 'DESC'})
    }
    if(ev?.target?.value==='os'){
      handleColumns(['version', 'rev', 'platform', 'versionstring', 'api', 'link', 'first_seen', 'update_cnt', 'last_hostel', 'last_seen', 'ospercent', 'osversion', 'oshostel', 'oslastseen'], true)
      setSort({field: 'version', order: 'DESC'})
    }
    if(ev?.target?.value==='act'){
      handleColumns(['aversion', 'cnt', 'proz', 'stat'], true)
      setSort({field: 'aversion', order: 'DESC'})
    }
  }

  const handleReset = () => {
    setSort({})
  }

  return (
    <>
      <Filter {...props}>
        <SelectInput source="time" alwaysOn choices={timeChoices} />
        <SelectInput source="platform" alwaysOn choices={osChoices} />
        <RadioButtonGroupInput source="view" alwaysOn choices={viewChoices} onChange={handleViewChange} />
        <TextInput source="q" label="Search" resettable alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }}/>
      </Filter>
      <Button variant="contained" source="reset" onClick={handleReset} sx={{ width: '12em'}}>Reset Sort</Button>
    </>
  )
};

const LinkField = ({source}) => {
  const rec = useRecordContext()
  const target = "https://app.bookdotworld.com"
  if(!rec || !source || !rec[source]) return null
  return (
    <a href={target+rec[source]}>X</a>
  )
}

const filterDefaultValues = {
  time: '99d',
  platform: 'all',
  view: 'min',
}

const StationField = ({source}) => {
  const rec = useRecordContext()
  if(!rec || !source || !rec[source]) return null
  return (
    <div key={rec['id']+'sf'}>
      {rec[source].split('|').map((part, index) => {console.log([part, index]);return (
        <div key={rec['id']+'st'+index}>{part}</div>
      )})}
    </div>
  )
}

const TextFieldBG = ({bgsource='osdays', ...props}) => {
  const rec = useRecordContext()
  var color = bgColors[0]
  if(!rec || !bgsource || typeof rec?.[bgsource] === 'undefined') return null
  if(rec[bgsource] > 1)  color = bgColors[1]
  if(rec[bgsource] > 7)  color = bgColors[2]
  if(rec[bgsource] > 30) color = bgColors[3]
  if(rec[bgsource] > 99) color = bgColors[4]
  if(rec[bgsource] > 365)color = bgColors[5]
  return (
    <TextField {...props} sx={{backgroundColor: color, p: '.2em'}} />
  )
}

const getRowStyle = (rec, index) => {
  const source = 'days'
  if(typeof rec?.[source] === 'undefined')return {backgroundColor: bgColors[6]}
  var color = bgColors[0]
  if(rec[source] > 1)  color = bgColors[1]
  if(rec[source] > 7)  color = bgColors[2]
  if(rec[source] > 30) color = bgColors[3]
  if(rec[source] > 99) color = bgColors[4]
  if(rec[source] > 365)color = bgColors[5]
  return {backgroundColor: color}
}

const ListForm = (props) => {
  return (
    <ListBase {...props} filter={{global: true}} filterDefaultValues={filterDefaultValues} filters={<ListFilter />} title="bw.set.prefcountry.title" sort={{ field: 'id', order: 'DESC' }} perPage={100} disableSyncWithLocation >
      <ListToolbar />
      <DatagridConfigurable style={{ width: 'auto' }} bulkActionButtons={false} omit={['ospercent', 'osversion', 'oshostel', 'oslastseen', 'aversion', 'count', 'proz', 'stations']} sx={{ '& .MuiTableCell-root': { p: '0.2em', pr: '.3em'} }} rowStyle={getRowStyle} >
        <TextField source="version" />
        <TextField source="aversion" label="Version" />
        <TextField source="rev" label="Revision" textAlign="right" />
        <TextField source="platform" label="OS" textAlign="right" />
        <TextField source="versionstring" label="Version (String)" />
        <TextField source="api" label="API" />
        <LinkField source="link" textAlign="center" />
        <TextField source="first_seen" />
        <TextField source="update_cnt" label="getUpdate Calls" textAlign="right" />
        <TextField source="last_hostel" textAlign="right" />
        <TextField source="last_seen" />
        <TextFieldBG source="ospercent" label="%" textAlign="right" />
        <TextFieldBG source="osversion" label="OS" />
        <TextFieldBG source="oshostel" label="last hid" textAlign="right" />
        <TextFieldBG source="oslastseen" label="os last seen" textAlign="right" />
        <TextField source="db_version_id" label="ID" textAlign="right" />
        <TextField source="cnt" textAlign="right" />
        <TextField source="proz" label="%" textAlign="right" />
        <StationField source="stat" label="Station" />
      </DatagridConfigurable>
      <MyPagination />
    </ListBase>
  )
}


const App = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} />
  )
}   
export default App